import { gql } from "lib/apolloClient";
import { projectTaskResponseFragment } from "./DeadlinesV2Fragments";
import {
  studentsAlertFragment,
  userNameFragment,
} from "modules/CommonFragments";

// TODO : will create fragments in next phase

export const getProjectGroupDeadlinesV2Query = gql`
  query getProjectGroupDeadlinesV2(
    $projectGroupId: ID!
    $projectTaskFilters: ProjectGroupTaskFilters
    $projectGroupTaskResponsesFilters: ProjectGroupTaskResponsesFilters
  ) {
    node(id: $projectGroupId, type: PROJECT_GROUP) {
      ... on ProjectGroup {
        id
        tasks(filters: $projectTaskFilters) {
          edges {
            node {
              id

              title
              description
              dueOn
              closesOn
              isStudentSubmissionEnabled
              status
              isDeadlineAllDay

              responses(filters: $projectGroupTaskResponsesFilters) {
                id
                isComplete
                isSubmissionTurnedIn
                isSubmissionLocked
                project {
                  id
                  students {
                    ...userNameFields
                    profileImage
                  }
                }
              }

              resources {
                edges {
                  node {
                    id
                    label
                    attachment {
                      id
                      name
                      type
                      mimeType
                      url
                      signedUrl
                      thumbUrl
                      title
                      metadata
                      streamUrl
                      parentType
                    }
                  }
                }
              }

              submission {
                id
                type
                items {
                  id
                  template {
                    id
                    name
                    type
                    mimeType
                    url
                    signedUrl
                    thumbUrl
                    title
                    metadata
                    streamUrl
                    parentType
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${userNameFragment}
`;

export const getProjectGroupDeadlinesCountQuery = gql`
  query getProjectGroupDeadlinesCount($projectGroupId: ID!) {
    node(id: $projectGroupId, type: PROJECT_GROUP) {
      ... on ProjectGroup {
        id
        tasks {
          totalCount
        }
      }
    }
  }
`;

export const getDeadlinesV2BasicDetailsQuery = gql`
  query getDeadlinesV2BasicDetails(
    $id: ID!
    $responseFilters: ProjectGroupTaskResponsesFilters
  ) {
    node(id: $id, type: PROJECT_GROUP_TASK) {
      ... on ProjectGroupTask {
        id
        title
        description
        dueOn
        closesOn
        isStudentSubmissionEnabled
        isDeadlineAllDay
        submission {
          id
          type
          fieldUID
          items {
            id
            title
            fieldUID
            template {
              id
              name
              type
              mimeType
              url
              signedUrl
              thumbUrl
              title
              metadata
              streamUrl
              parentType
            }
          }
        }
        resources {
          edges {
            node {
              id
              label
              attachment {
                id
                name
                type
                mimeType
                url
                signedUrl
                thumbUrl
                title
                metadata
                streamUrl
                parentType
              }
            }
          }
        }
        responses(filters: $responseFilters) {
          id
          isComplete
          isSubmissionTurnedIn
          project {
            id
            students {
              ...userNameFields
              profileImage
            }
          }
        }
      }
    }
  }
  ${userNameFragment}
`;

export const getProjectGroupProjectsWithDeadlineDetailsQuery = gql`
  query getProjectGroupProjectsWithDeadlineDetails(
    $projectGroupId: ID!
    $projectFilters: ProjectGroupProjectsFilters
    $projectTaskFilters: ProjectTaskFilters
  ) {
    node(id: $projectGroupId, type: PROJECT_GROUP) {
      ... on ProjectGroup {
        id

        projects(filters: $projectFilters) {
          totalCount
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              reportStatus
              students {
                ...userNameFields
                profileImage
                registrationCategory
                alertTypes {
                  ...alertTypeFields
                }
              }

              tasks(filters: $projectTaskFilters) {
                ...projectTaskResponseItem
              }
            }
          }
        }
      }
    }
  }
  ${studentsAlertFragment}
  ${projectTaskResponseFragment}
  ${userNameFragment}
`;

export const getProjectGroupProjectsWithStudentDetailsQuery = gql`
  query getProjectGroupProjectsWithStudentDetails(
    $projectGroupId: ID!
    $projectFilters: ProjectGroupProjectsFilters
  ) {
    node(id: $projectGroupId, type: PROJECT_GROUP) {
      ... on ProjectGroup {
        id
        projects(filters: $projectFilters) {
          totalCount
          edges {
            node {
              id
              students {
                ...userNameFields
                profileImage
                alertTypes {
                  ...alertTypeFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${studentsAlertFragment}
  ${userNameFragment}
`;

export const getProjectDetailsWithTaskQuery = gql`
  query getProjectIBDefinedTasks(
    $id: ID!
    $projectTaskFilters: ProjectTaskFilters
  ) {
    node(id: $id, type: PROJECT) {
      ... on Project {
        id
        reportStatus
        tasks(filters: $projectTaskFilters) {
          ...projectTaskResponseItem
        }
      }
    }
  }
  ${projectTaskResponseFragment}
`;
